/**
 * Route for `custom-partner-email-sender-domain-smtp-relay`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomPartnerEmailSenderDomainSmtpRelayPage } from "../features/custom-partner-email-sender-domain-smtp-relay/CustomPartnerEmailSenderDomainSmtpRelayPage";

export const customPartnerEmailSenderDomainSmtpRelayRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-partner-email-sender-domain-smtp-relay",
	component: CustomPartnerEmailSenderDomainSmtpRelayPage,
});

export default customPartnerEmailSenderDomainSmtpRelayRoute;
